import { Route, Routes } from 'react-router-dom';

import { ErrorPage } from '~/chords';
import { useDdexAccess } from '~/modules/ddex-console/hooks/useDdexAccess';
import { ErrorContent } from '~/modules/errors/components/ErrorContent';
import { LoadingScreen } from '~/modules/navigation/components/LoadingScreen';

import { DdexConsole } from './components/DdexConsole';

function Router() {
  const { hasDdexAccess, isLoading } = useDdexAccess();

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      <Route
        index
        element={
          hasDdexAccess ? <DdexConsole /> : <ErrorContent type="noAccess" />
        }
      />

      <Route path="*" element={<ErrorPage type="notFoundPage" />} />
    </Routes>
  );
}

Router.displayName = 'DdexConsoleRouter';

export { Router };
